import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, info) {
    // eslint-disable-next-line no-console
    console.error("BKPROD — erreur interface", erreur, info?.componentStack);
  }

  render() {
    if (!this.state.erreur) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center px-6 bg-[#0A0A0A] text-white" data-testid="error-boundary">
        <div className="max-w-md text-center space-y-5">
          <AlertTriangle size={34} className="mx-auto text-[#005CFF]" />
          <div>
            <div className="font-display text-2xl font-extrabold tracking-tighter">Une erreur est survenue</div>
            <p className="text-sm text-white/60 mt-2">
              L'action a peut-être bien été enregistrée. Rechargez la page pour continuer ; si le problème persiste, signalez-le à BKPRO.
            </p>
          </div>
          <p className="text-[11px] text-white/35 font-mono break-words">{String(this.state.erreur?.message || this.state.erreur)}</p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 text-sm font-semibold px-5 py-3 rounded-full bg-[#005CFF] hover:bg-[#0047CC] transition-colors"
          >
            <RefreshCw size={15} /> Recharger l'application
          </button>
        </div>
      </div>
    );
  }
}
